export const routes = {
  profile: {
    select: "/profile/select",
    create: "/profile/create",
    edit: "/profile/edit",
  },
};
